exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".radio-value[data-v-6fa525eb]{min-width:54px}.radio-checkbox[data-v-6fa525eb]{margin-left:1rem!important;top:-6px}", ""]);

// exports
